/*
═══════════════════════════════════════════════════════════
НАСТРОЙКА НА ЯСНОСТЬ / CLARITY
═══════════════════════════════════════════════════════════
Автор: @Elena_evolvecode
Telegram: @na_sh_kodila
Создано: 2025-2026
Все права защищены
═══════════════════════════════════════════════════════════
*/

import React from 'react';

const TaskCard = ({ type, task, count, isCompleted, onAction }) => {
  const isBody = type === 'body';
  const icon = isBody ? '◯' : '◇';
  const label = isBody ? 'Тело' : 'Речь';

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <span style={styles.icon}>{icon}</span>
        <span style={styles.label}>{label}</span>
      </div>

      <h3 style={styles.taskName}>{task.name}</h3>

      <p style={styles.action}>{task.action}</p>

      {/* Примеры курсивом */}
      {task.examples && task.examples.length > 0 && (
        <div style={styles.examplesContainer}>
          {task.examples.map((example, index) => (
            <p key={index} style={styles.example}>{example}</p>
          ))}
        </div>
      )}

      {/* Для задания Тело — счётчик */}
      {isBody && (
        <div style={styles.counterSection}>
          <button
            style={styles.counterButton}
            onClick={onAction}
          >
            +1
          </button>
          <span style={styles.counterText}>
            {count} {task.metric_label}
          </span>
        </div>
      )}

      {/* Для задания Речь — чекбокс */}
      {!isBody && (
        <div style={styles.checkboxSection}>
          <button
            style={{
              ...styles.checkbox,
              ...(isCompleted ? styles.checkboxCompleted : {}),
            }}
            onClick={onAction}
          >
            {isCompleted ? '✓' : ''}
          </button>
          <span style={styles.checkboxLabel}>
            {isCompleted ? 'Выполнено' : 'Отметить выполнение'}
          </span>
        </div>
      )}
    </div>
  );
};

const styles = {
  card: {
    background: 'linear-gradient(135deg, #0d0d0d 0%, #1a1a1a 100%)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.3)',
    borderRadius: '16px',
    padding: '20px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
  },
  icon: {
    color: '#E5D2A0',
    fontSize: '16px',
  },
  label: {
    color: '#E5D2A0',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '2px',
    textTransform: 'uppercase',
  },
  taskName: {
    color: '#FFFFFF',
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 0 12px 0',
  },
  action: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: '0 0 12px 0',
  },
  examplesContainer: {
    marginBottom: '12px',
    paddingLeft: '12px',
    borderLeftWidth: '2px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'rgba(229, 210, 160, 0.3)',
  },
  example: {
    color: 'rgba(229, 210, 160, 0.8)',
    fontSize: '13px',
    lineHeight: '1.5',
    fontStyle: 'italic',
    margin: '0 0 8px 0',
  },
  counterSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '16px',
  },
  counterButton: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: '#E5D2A0',
    background: 'transparent',
    color: '#E5D2A0',
    fontSize: '18px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  counterText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
  },
  checkboxSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginTop: '16px',
  },
  checkbox: {
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.5)',
    background: 'transparent',
    color: '#E5D2A0',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxCompleted: {
    background: 'rgba(229, 210, 160, 0.2)',
    borderColor: '#E5D2A0',
  },
  checkboxLabel: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
  },
};

export default TaskCard;
